import Bus from '../../asset/images/Bus.png'
import { useCallback, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import MultiBusMap from './MultiBusMap'
import { fetchSchoolList } from '../school/api'

const LiveBusMap = ({ busGeoJson, schoolLocation }) => {
  const [center, setCenter] = useState(schoolLocation)
  const [selectedLocation, setSelectedLocation] = useState('school')
  const [schoolName, setSchoolName] = useState('')

  const navigate = useNavigate()

  const onMarkerClick = useCallback((clickedBusGeoJSON) => {
    navigate('/trip/track-bus', { state: clickedBusGeoJSON })
  }, [])

  useEffect(() => {
    async function loadSchool() {
      try {
        const res = await fetchSchoolList()
        // Your API shape:
        // { status: true, data: { school_name: "Demo School", ... } }
        if (res?.data?.school_name) {
          setSchoolName(res.data.school_name)
        } else {
          setSchoolName('School Name')
        }
      } catch (e) {
        setSchoolName('School Name')
      }
    }

    loadSchool()
  }, [])

  return (
    <div style={{ height: '80vh', width: '100%' }} className="d-flex">
      <div className="w-75 h-100">
        <MultiBusMap
          center={center}
          busGeoJson={busGeoJson}
          onMarkerClick={onMarkerClick}
          schoolLocation={schoolLocation}
        />
      </div>

      <div className="w-25 overflow-auto bg-white">
        <div
          className={`d-flex rounded mb-2 ps-2 ${selectedLocation === 'school' && 'app-default'}`}
          role="button"
          onClick={() => {
            setCenter(schoolLocation)
            setSelectedLocation('school')
          }}
        >
          <div className="p-4 fs-4 text-center d-flex align-items-end">
            <i className="la la-city fs-2hx text-warning"></i>{' '}
            <span className="ps-2 ">{schoolName || 'Loading...'}</span>
          </div>
        </div>

        {busGeoJson.features.length > 0 ? (
          busGeoJson.features.map((bus) => (
            <div
              className={`d-flex rounded mb-2 ps-2 ${
                bus.properties.bus_registration_number === selectedLocation && 'app-default'
              }`}
              role="button"
              onClick={() => {
                setCenter({
                  lat: bus.geometry.coordinates[1],
                  lng: bus.geometry.coordinates[0],
                })
                setSelectedLocation(bus.properties.bus_registration_number)
              }}
              key={bus.properties.bus_registration_number}
            >
              <div className="p-2 align-self-center">
                <img src={Bus} alt="Bus Icon" style={{ width: '50px' }} />
              </div>
              <div className="p-2">
                <div className="pb-2">{bus.properties.bus_name}</div>
                <div>Reg. Number: {bus.properties.bus_registration_number}</div>
              </div>
            </div>
          ))
        ) : (
          <div className="p-4 text-center fs-5">No vehicles activated with GPS today</div>
        )}
      </div>
    </div>
  )
}

export default LiveBusMap
